import { useCallback, useEffect, useRef, useState } from 'react'

import { Col, Form, Modal, Row, Table } from 'react-bootstrap'
import { CheckCircleFill, Search, XCircleFill } from 'react-bootstrap-icons'

import axios from 'axios'
import { toast } from 'react-toastify'
import { Ask } from '../../../../components/Ask'
import { Center } from '../../../../components/Center'
import { CustomButton } from '../../../../components/CustomButton'
import { CustomSpinner } from '../../../../components/CustomSpinner'
import { IconButton } from '../../../../components/IconButton'
import { useOrdenation } from '../../../../hooks/useOrdenation'
import WmsAddressService from '../../../../services/database/WmsAddressService'
import WmsPickingService from '../../../../services/database/WmsPickingService'
import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'

export function ModalEnderecamento({
  isOpen,
  productSku,
  onClose,
  title,
  loadProducts,
}) {
  const [data, setData] = useState({
    codendereco: '',
    sku: '',
    pontoreposicao: '',
    capacidade: '',
  })
  const [selectedAddress, setSelectedAddress] = useState({})
  const [isCreateProductPickingLoading, setIsCreateProductPickingLoading] =
    useState(false)
  const [isAddressesLoading, setIsAdressesLoading] = useState(true)
  const [isProductPickingLoading, setIsProductPickingLoading] = useState(false)
  const [addresses, setAddresses] = useState([])
  const [isModalSelectAddressOpen, setIsModalSelectAddressOpen] =
    useState(false)
  const [searchAddress, setSearchAddress] = useState({
    codendereco: '',
    deposito: '',
    rua: '',
    predio: '',
    nivel: '',
    apto: '',
  })
  const [isSearchAddressLoading, setIsSearchAddressLoading] = useState(false)

  const inputCapacidadeRef = useRef(null)
  const inputCodEnderecoRef = useRef(null)

  const { filteredItems, Th, Paginate, itemsPerPage, setItemsPerPage } =
    useOrdenation(addresses, 'codendereco')

  function handleChange(e) {
    const { name, value } = e.target

    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  function handleChangeAddress(e) {
    const { name, value } = e.target

    setSearchAddress((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  async function loadAddresses() {
    try {
      setIsAdressesLoading(true)

      const data = await WmsAddressService.getAll('S')

      setAddresses(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar os endereços!')
    } finally {
      setIsAdressesLoading(false)
    }
  }

  async function handleSearchAddress() {
    try {
      setIsSearchAddressLoading(true)

      const addressesData = await WmsAddressService.getBySearch({
        codendereco: searchAddress.codendereco,
        rua: searchAddress.rua,
        deposito: searchAddress.deposito,
        apto: searchAddress.apto,
        nivel: searchAddress.nivel,
        predio: searchAddress.predio,
      })

      setAddresses(addressesData)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar o endereço!')
    } finally {
      setIsSearchAddressLoading(false)
    }
  }

  async function handleSelectAddress(address) {
    if (address.situacao === 'O') {
      await Ask('Endereço ocupado, deseja selecionar assim mesmo?', () => {
        setData((prevState) => ({
          ...prevState,
          codendereco: address.codendereco,
        }))

        setSelectedAddress(address)

        setIsModalSelectAddressOpen(false)
      })
    } else {
      setData((prevState) => ({
        ...prevState,
        codendereco: address.codendereco,
      }))

      setSelectedAddress(address)

      setIsModalSelectAddressOpen(false)
    }

    setTimeout(() => {
      inputCapacidadeRef?.current.focus()
    }, 100)
  }

  async function handleSaveProductPicking() {
    if (Number(data.pontoreposicao) > Number(data.capacidade)) {
      return toast.error(
        'Ponto de reposição deve ser igual ou menor do que a capacidade!',
      )
    }

    try {
      setIsCreateProductPickingLoading(true)

      await WmsPickingService.create(data)

      loadProducts()
      toast.success('Endereço anexado com sucesso!')
      onClose()
    } catch (err) {
      if (axios.isCancel(err)) {
        return
      } else {
        sendErrorApiMessage(err, 'Não foi possível criar o picking do produto!')
      }
    } finally {
      setIsCreateProductPickingLoading(false)
    }
  }

  async function getProductPickingBySKU(sku) {
    try {
      setIsProductPickingLoading(true)

      const pickingData = await WmsPickingService.getBySKU(sku)

      setData((prevState) => ({
        ...prevState,
        codendereco: pickingData?.codendereco || '',
        capacidade: pickingData?.capacidade || '',
        pontoreposicao: pickingData?.pontoreposicao || '',
      }))
    } catch (err) {
      sendErrorApiMessage(
        err,
        'Não foi possível carregar as informações de picking!',
      )
    } finally {
      setIsProductPickingLoading(false)
    }
  }

  function handleEnterPress(e) {
    if (e.ctrlKey && e.key === 'Enter') {
      return
    } else if (e.key === 'Enter') {
      handleSearchAddress()
    }
  }

  const commands = useCallback((e) => {
    if (e.ctrlKey && e.shiftKey && String(e.key).toLowerCase() === 'l') {
      setData({
        codendereco: '',
        sku: '',
        capacidade: '',
        pontoreposicao: '',
      })

      loadAddresses()
    }
  }, [])

  useEffect(() => {
    if (isModalSelectAddressOpen) {
      inputCodEnderecoRef?.current.focus()
    }
  }, [isModalSelectAddressOpen])

  useEffect(() => {
    document.body.addEventListener('keydown', commands)

    return () => {
      document.body.removeEventListener('keydown', commands)
    }
  }, [commands])

  useEffect(() => {
    if (productSku) {
      getProductPickingBySKU(productSku)
    }
  }, [productSku])

  useEffect(() => {
    if (isModalSelectAddressOpen) {
      loadAddresses()
    }
  }, [isModalSelectAddressOpen])

  useEffect(() => {
    if (productSku) {
      setData((prevState) => ({
        ...prevState,
        sku: productSku,
      }))
    }
  }, [productSku])

  return (
    <>
      <Modal
        show={isOpen}
        onHide={onClose}
        centered
      >
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {isProductPickingLoading ? (
            <Center>
              <CustomSpinner size={22} />
              <p
                style={{
                  margin: 0,
                }}
              >
                Carregando Picking...
              </p>
            </Center>
          ) : (
            <>
              <Row className="mb-3">
                <Col>
                  <Form.Label>Cód. Ender.</Form.Label>

                  <div
                    style={{
                      display: 'flex',
                      gap: 5,
                    }}
                  >
                    <Form.Control
                      name="codendereco"
                      value={data.codendereco}
                      onChange={handleChange}
                      disabled
                    />

                    <IconButton
                      isDisabled={data.codendereco}
                      onClick={() => {
                        setIsModalSelectAddressOpen(true)
                      }}
                    >
                      <Search />
                    </IconButton>
                  </div>
                </Col>

                <Col>
                  <Form.Label>SKU</Form.Label>
                  <Form.Control
                    name="sku"
                    value={data.sku}
                    onChange={handleChange}
                    disabled
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col>
                  <Form.Label>Capacidade</Form.Label>
                  <Form.Control
                    ref={inputCapacidadeRef}
                    name="capacidade"
                    value={data.capacidade}
                    onChange={handleChange}
                  />
                </Col>

                <Col>
                  <Form.Label>Reposição</Form.Label>
                  <Form.Control
                    name="pontoreposicao"
                    value={data.pontoreposicao}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleSaveProductPicking()
                      }
                    }}
                  />
                </Col>
              </Row>

              {selectedAddress.codendereco && (
                <Center>
                  <p>
                    Rua: <strong>{selectedAddress?.rua}</strong> - Préd:{' '}
                    <strong>{selectedAddress?.predio}</strong> - Nvl:{' '}
                    <strong>{selectedAddress?.nivel}</strong> - Apto:{' '}
                    <strong>{selectedAddress?.apto}</strong> -
                    <strong>{selectedAddress?.tipoender}</strong>
                  </p>
                </Center>
              )}
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <CustomButton
            title="Salvar"
            color="#08a500"
            onClick={handleSaveProductPicking}
            isLoading={isCreateProductPickingLoading}
            isDisabled={isProductPickingLoading}
            isLoadingText="Salvando..."
          >
            <CheckCircleFill />
          </CustomButton>

          <CustomButton
            title="Cancelar"
            color="#ff0000"
            onClick={onClose}
          >
            <XCircleFill />
          </CustomButton>
        </Modal.Footer>
      </Modal>

      {isModalSelectAddressOpen && (
        <Modal
          show={isModalSelectAddressOpen}
          onHide={() => {
            setIsModalSelectAddressOpen(false)
          }}
          dialogClassName="custom-modalzpl"
          centered
        >
          <Modal.Header>
            <Modal.Title>Selecionar Endereço</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div
              style={{
                padding: '0 15px',
              }}
            >
              <Row className="mb-3">
                <Col>
                  <Form.Label>Cód. End.</Form.Label>
                  <Form.Control
                    ref={inputCodEnderecoRef}
                    name="codendereco"
                    value={searchAddress.codendereco}
                    onChange={handleChangeAddress}
                    onKeyDown={handleEnterPress}
                  />
                </Col>

                <Col>
                  <Form.Label>Depósito</Form.Label>
                  <Form.Control
                    name="deposito"
                    value={searchAddress.deposito}
                    onChange={handleChangeAddress}
                    onKeyDown={handleEnterPress}
                  />
                </Col>

                <Col>
                  <Form.Label>Rua</Form.Label>
                  <Form.Control
                    name="rua"
                    value={searchAddress.rua}
                    onChange={handleChangeAddress}
                    onKeyDown={handleEnterPress}
                  />
                </Col>

                <Col>
                  <Form.Label>Prédio</Form.Label>
                  <Form.Control
                    name="predio"
                    value={searchAddress.predio}
                    onChange={handleChangeAddress}
                    onKeyDown={handleEnterPress}
                  />
                </Col>

                <Col>
                  <Form.Label>Nível</Form.Label>
                  <Form.Control
                    name="nivel"
                    value={searchAddress.nivel}
                    onChange={handleChangeAddress}
                    onKeyDown={handleEnterPress}
                  />
                </Col>

                <Col>
                  <Form.Label>Apartamento</Form.Label>
                  <Form.Control
                    name="apto"
                    value={searchAddress.apto}
                    onChange={handleChangeAddress}
                    onKeyDown={handleEnterPress}
                  />
                </Col>

                <Col
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'flex-end',
                  }}
                >
                  <CustomButton
                    title="Buscar"
                    onClick={handleSearchAddress}
                    isLoading={isSearchAddressLoading}
                    isLoadingText="Buscando..."
                  >
                    <Search />
                  </CustomButton>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Label>Endereços por página</Form.Label>
                  <Form.Select
                    onChange={(e) => {
                      setItemsPerPage(Number(e.target.value))
                    }}
                    style={{
                      width: '200px',
                    }}
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Select>
                </Col>
              </Row>

              {isAddressesLoading ? (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 10,
                  }}
                >
                  <CustomSpinner size={40} />
                  <h1
                    style={{
                      margin: 0,
                    }}
                  >
                    Carregando endereços...
                  </h1>
                </div>
              ) : filteredItems.length === 0 ? (
                <div
                  style={{
                    height: '100vh',
                    padding: 20,
                    textAlign: 'center',
                  }}
                >
                  <h5>Sem endereços encontrados!</h5>
                </div>
              ) : (
                <>
                  <Center jc="flex-end">
                    <p>
                      Mostrando <strong>{itemsPerPage}</strong> de{' '}
                      <strong>{addresses.length}</strong> endereços
                    </p>
                  </Center>
                  <Table
                    striped
                    bordered
                    hover
                  >
                    <thead>
                      <tr>
                        <Th
                          value="codendereco"
                          label="Código"
                        />
                        <Th
                          value="deposito"
                          label="Depósito"
                        />
                        <Th
                          value="rua"
                          label="Rua"
                        />
                        <Th
                          value="predio"
                          label="Prédio"
                        />
                        <Th
                          value="nivel"
                          label="Nível"
                        />
                        <Th
                          value="apto"
                          label="Apartamento"
                        />
                      </tr>
                    </thead>

                    <tbody>
                      {filteredItems.map((address) => (
                        <tr
                          key={address.codendereco}
                          onClick={() => handleSelectAddress(address)}
                          style={{
                            cursor: 'pointer',
                          }}
                        >
                          <td>{address.codendereco}</td>
                          <td>{address.deposito}</td>
                          <td>{address.rua}</td>
                          <td>{address.predio}</td>
                          <td>{address.nivel}</td>
                          <td>{address.apto}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  <Paginate />
                </>
              )}
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  )
}
